export const formatMongoDBTime = (timestamp) => {
  const dateObj = new Date(timestamp);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const year = dateObj.getFullYear();
  const month = months[dateObj.getMonth()];
  const date = dateObj.getDate();

  const hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  const seconds = String(dateObj.getSeconds()).padStart(2, "0");

  const formattedTime = convertTo12HourFormat(hours, minutes, seconds);

  return `${year} ${month} ${date} & ${formattedTime}`;
};

const convertTo12HourFormat = (hours, minutes, seconds) => {
  const period = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12;

  return `${hours12}:${minutes}:${seconds} ${period}`;
};
